export default "/images/vendor/flag-icon-css/flags/1x1/cc.svg?d20d3e0cf1bec347594d0a88b8f40c6a";